import React from 'react';
import { CentralProviderFooter, maestroApiCall } from '@michelin/central-provider';
import { useQuery } from 'react-query';
import { getBEVersion } from 'Types/APITypes';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { getVersion } from 'Utils';

export function Footer() {
  const beVersionQuery = useQuery(['be-version'], () => maestroApiCall(getBEVersion()), {
    cacheTime: 3600,
    keepPreviousData: true,
  });
  const beVersion = beVersionQuery.data?.version.split('-').pop() || '  -loading-';

  if (runningOnCanvas()) return null;

  return (
    <CentralProviderFooter
      versions={[
        {
          application: 'UI',
          version: getVersion() || '',
        },
        {
          application: 'API',
          version: beVersion,
        },
      ]}
      showLegalInformation={false}
      showCopyright
    />
  );
}
